// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-ad-view .home-ad-group .home-ad-img{width:100%}", ""]);
// Exports
module.exports = exports;
